module.exports = __webpack_public_path__ + "static/media/rate.8a4ffd56.svg";